import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { useInView } from 'react-intersection-observer'
import { useGetQuery } from '../../../../hooks'

const InView = ({ children, onInView, isLoad, options }) => {
  const { ref, inView } = useInView(options)
  const { workspaceid } = useGetQuery()

  useEffect(() => {
    if (inView && isLoad) onInView()
  }, [inView, isLoad, workspaceid])

  return <div ref={ref}>{children}</div>
}

InView.propTypes = {
  children: PropTypes.node,
  onInView: PropTypes.func,
  isLoad: PropTypes.bool,
  options: PropTypes.object
}

export default InView
